/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Extension_Demosubtitle1Inputs */

const he_extension_demosubtitle1 = /** @type {(inputs: Extension_Demosubtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`התוסף מוסיף מידע עשיר ישירות לעמודי המוצרים ב-KSP`)
};

const en_extension_demosubtitle1 = /** @type {(inputs: Extension_Demosubtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The extension adds rich data directly to KSP product pages`)
};

/**
* | output |
* | --- |
* | "The extension adds rich data directly to KSP product pages" |
*
* @param {Extension_Demosubtitle1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const extension_demosubtitle1 = /** @type {((inputs?: Extension_Demosubtitle1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Extension_Demosubtitle1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_extension_demosubtitle1(inputs)
	return en_extension_demosubtitle1(inputs)
});
export { extension_demosubtitle1 as "extension_demoSubtitle" }